import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { ICommonAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import { OpacityIcon } from '@assets/icons/opacityIcon';
import Tooltip from '@components/Tooltip';
import ClickOutside from '@components/ClickOutside';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const OpacityCommandOption : React.FC<IProps> = () => {
  let { editorStatus, data, onCommandChange} = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);  
  const [opacity, setOpacity]= useState<number|undefined>(100);  
  const [inputOpacity, setInputOpacity]= useState<string>();  
  const startOpacitySlider = 100;
  const minOpacitySlider = 0;
  const maxOpacitySlider = 100;

  useEffect(() => {
    let opacityValue = findCommonAttributeValue(editorStatus.selectedElementsId, data, "opacity");
    if (opacityValue===undefined) opacityValue="100";
    else {
      opacityValue = (parseFloat(opacityValue)*100).toString();
    }
    setOpacity(parseInt(opacityValue));
    setInputOpacity(opacityValue);
  }, [editorStatus.selectedElementsId.length,editorStatus.selectedElementsId[0],data]);

  const SetOpacity = (value: number|undefined, notSave?: boolean) => {
    setOpacity(value);    
    onCommandChange("opacity", (value??100)/100,undefined, undefined, notSave);          
  }

  const handleInputOpacitySlider = (e: any) => {
    const inputText = e.target.value;

    if(inputText==="") {
      SetOpacity(0);
      setInputOpacity(inputText);
    }

    if(!isNaN(inputText) && parseInt(inputText)>=minOpacitySlider && parseInt(inputText)<=maxOpacitySlider) {
      setInputOpacity(inputText);
      SetOpacity(parseInt(inputText));
    }
  }

  return (    
    <S.Root>

      <ClickOutside onClickOutside={()=> setIsSelected(false)}>
        <Tooltip tip={"Opacity"} boxStyle={isSelected ? {display:'none'}:undefined}>
          <S.ButtonContainer onClick={()=> setIsSelected(!isSelected)} isSelected={isSelected}>
            <OpacityIcon/>
          </S.ButtonContainer>
        </Tooltip>
        <S.OptionsList style={{ display: isSelected ? "flex" : "none"}}>
          <S.optionContainer>
              <S.Label>
                Opacity
              </S.Label>
              <S.SliderContainer>
              <Slider
                min={minOpacitySlider}
                max={maxOpacitySlider}
                step={1}
                startPoint={startOpacitySlider}                
                value={opacity!==undefined?opacity:startOpacitySlider}
                onChange={(e)=> {SetOpacity(e,true); setInputOpacity(e.toString())}}
                onAfterChange={(e)=>{SetOpacity(e); setInputOpacity(e.toString())}}
                railStyle={{
                  height:1,
                  background: "#818181"
                  
                }}
                handleStyle={{
                  height: 10,
                  width: 10,                
                  marginTop: -4,
                  backgroundColor: "#c4c4c4",
                  border: 0
                }}
                trackStyle={{
                  height:1,
                  background: "none"
                }}
                dotStyle={{
                  border:0,
                  height:5,
                  width:5,
                  top:-2,
                  background: "#c4c4c4"

                }}
                
              />
              </S.SliderContainer>
              <S.InputSlider
                value={opacity!==undefined?opacity:"100"}
                onChange={handleInputOpacitySlider}
              ></S.InputSlider>
            </S.optionContainer>
          </S.OptionsList>
      </ClickOutside>

    </S.Root>
  );
}

export default OpacityCommandOption;